import { render, staticRenderFns } from "./CategoryContents.vue?vue&type=template&id=090f6a98&scoped=true&"
import script from "./CategoryContents.vue?vue&type=script&lang=js&"
export * from "./CategoryContents.vue?vue&type=script&lang=js&"
import style0 from "./CategoryContents.vue?vue&type=style&index=0&id=090f6a98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "090f6a98",
  null
  
)

export default component.exports